import { Button } from '@vapor/material'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CreateCoParameter } from 'src/app/pages/accounting/documents/checkout-document/checkout-document-form'
import { BillF, DepositF } from '../../../../../types/reservation-detail.types'
import { reduceAssignedProductions } from '../../../../../utils/bills'
import { SelectionDialog } from './selection-dialog'
import { faFileInvoice } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export type CreateCheckoutDocumentProps = {
  bills: BillF[]
  deposits: DepositF[]
  selectedAssignedProductionIds: string[]
  onCreateDocument: (params: CreateCoParameter) => void
  disabled: boolean
}

export default function CreateCheckoutDocument({ bills, deposits, selectedAssignedProductionIds, onCreateDocument, disabled }: CreateCheckoutDocumentProps) {
  const { t } = useTranslation()
  const onClick = useCallback(() => {
    const aps = reduceAssignedProductions(bills).filter((ap) => selectedAssignedProductionIds.includes(ap.id))
    if (aps.length <= 0) {
      setSelectionDialogOpen(true)
    } else {
      onCreateDocument({
        billIds: bills.map((b) => b.id),
        productionAssignedIds: aps.map((ap) => ap.id),
        depositDocumentIds: deposits.map((d) => d.id),
      })
    }
  }, [bills, selectedAssignedProductionIds])

  const [selectionDialogOpen, setSelectionDialogOpen] = useState(false)

  return (
    <>
      <Button //
        variant="contained"
        size="small"
        onClick={onClick}
        disabled={disabled}
        startIcon={<FontAwesomeIcon icon={faFileInvoice} />}
      >
        {t('pms.booking.reservation.bills_action.create_document.title')}
      </Button>
      <SelectionDialog //
        bills={bills}
        open={selectionDialogOpen}
        onClose={(assignedProductionsId) => {
          setSelectionDialogOpen(false)
          if (assignedProductionsId.length > 0) {
            onCreateDocument({
              billIds: bills.map((b) => b.id),
              productionAssignedIds: assignedProductionsId,
              depositDocumentIds: deposits.map((d) => d.id),
            })
          }
        }}
      />
    </>
  )
}
